<template>
    <div class="wallet-marquee" v-if="walletConfig?.announcement?.value">
        <marquee>
            {{walletConfig?.announcement?.value}}
        </marquee>
    </div>
</template>

<script>
export default {
    name: 'WalletAnnoucement',
    inject: ['walletConfig'],
}
</script>